var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"class-desc"},[(_vm.$store.state.className)?_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.$store.state.className))]):_vm._e(),_c('div',{staticClass:"desc"},_vm._l((_vm.$store.state.classDesc.split('\n')),function(p){return _c('p',[_vm._v(_vm._s(p))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }